<script setup>
import { computed, reactive } from 'vue'
import iconUserPath from '../../../../../../images/sns/user'
import { Carousel, Pagination, Slide } from 'vue3-carousel'
import 'vue3-carousel/dist/carousel.css'
import {
  KkPreviewVideo
} from '../../../../components/domains/sns'
import { KkInfo } from '../../../../components/ui'

import iconInstagramPath from '../../../../../../images/sns/icon_instagram.svg'
const SHOW_TEXT_LENGTH = 38
const props = defineProps({
  text: { type: String, default: '' },
  images: { type: Array, default: () => [] },
  movie: { type: Object, default: null },
})
const state = reactive({
  showText: false
})
const isAvailablePreview = computed(() => props.movie.type === 'video/mp4') // 動画プレビュー機能はmp4のみ

const displayText = computed(() => isVisibleMoreTrigger.value ? props.text.substring(0, SHOW_TEXT_LENGTH) : props.text)
const isVisibleMoreTrigger = computed(() => !state.showText && props.text.length > SHOW_TEXT_LENGTH)
const imageStyles = (index, url) => {
  const styles = {}
  styles['background'] = `url(${ url }) center/cover no-repeat`
  return styles
}
</script>
<template>
  <div class="content">
    <div class="content__header">
      <img alt="" :src="iconInstagramPath" class="content__icon">
      {{ $t('components.snsPreview.title', { name: 'Instagram' }) }}
    </div>
    <div class="content__body">
      <template v-if="props.images.length === 0 && !props.movie">
        {{ $t('components.snsPreview.textAndMedia') }}
      </template>
      <div v-else class="preview">
        <div class="preview__profile">
          <img alt="" :src="iconUserPath" class="preview__icon">
          {{ $t('components.snsPreview.name') }}
        </div>
        <div v-if="props.images.length > 0" class="preview__imageContainer">
          <div v-if="props.images.length === 1" :style="imageStyles(0, props.images[0].url)" class="preview__image" />
          <Carousel v-else>
            <Slide v-for="(image, i) in props.images" :key="i">
              <div :style="imageStyles(i, image.url)" class="preview__image" />
              <div class="preview__imageCount">
                {{ `${ i + 1 }/${ props.images.length }` }}
              </div>
            </Slide>
            <template #addons>
              <Pagination />
            </template>
          </Carousel>
        </div>
        <KkPreviewVideo v-if="props.movie" :movie="props.movie" />
        <div class="preview__text">
          <span>{{ displayText }}</span>
          <span v-show="isVisibleMoreTrigger" class="c-more__trigger">...<strong @click="state.showText = true">{{ $t('labels.viewMore') }}</strong></span>
        </div>
      </div>
      <KkInfo v-if="props.movie && !isAvailablePreview" icon="exclamation" alert class="note">
        {{ $t('components.snsPreview.typeNote') }}
      </KkInfo>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.content {
  border: 3px solid #3A3B3F;
  border-radius: 4px;
  &__header {
    display: flex;
    align-items: center;
    background: #3A3B3F;
    color: #fff;
    padding: 10px;
    font-weight: bold;
  }
  &__body {
    background-color: #f1f1f1;
    padding: 10px;
  }
  &__icon {
    width: 16px;
    height: 16px;
    margin: 0 10px;
    background: #fff;
    border-radius: 16px;
  }
  .preview {
    width: 80%;
    padding: 10px 0;
    background: #fff;
    margin: 0 auto;
    &__profile {
      display: flex;
      align-items: center;
      margin-bottom: 15px;
      padding: 0 10px;
    }
    &__icon {
      height: 32px;
      width: 32px;
      margin-right: 5px;
    }
    &__imageContainer {
      margin-bottom: 15px;
    }
    &__image {
      position: relative;
      width: 100%;
      height: 300px;
    }
    &__text {
      padding: 10px;
      word-break: break-all;
      white-space: pre-wrap;
    }
    &__imageCount {
      position: absolute;
      right: 2%;
      top: 3%;
      border-radius: 20px;
      display: inline-block;
      padding: 1px 5px;
      color: #fff;
      font-size: 10px;
      background: #383d38;
    }
  }
}
:deep(.carousel__pagination-button) {
  width: 8px;
  height: 8px;
  margin: 4px;
  background-color: #a1a1a1;
  border-radius: 50%;
}
:deep(.carousel__pagination-button:after) {
  display: none;
}
:deep(.carousel__pagination-button--active) {
  background-color: #61beff;
}
.c-more__trigger strong {
  color: #a1a1a1;
}
.note {
  margin-top: 16px;
}
</style>
